export default "__VITE_ASSET__fbd231df__"